import React, { useMemo, useState, useContext } from "react";
import { Container, Modal, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ReactComponent as BookMarkDark } from "../bookmark-dark.svg";
import { ReactComponent as Home } from "../home.svg";
import { StoreContext } from "../Stores";
import { TYPES } from "../Reducers/bookmarkReducer";

export const Bookmark = ({ menus }) => {
  const contextValue = useContext(StoreContext);
  const [confirmUnBookmark, setConfirmUnBookmark] = useState({
    item: null,
    toggleModal: false,
    unBookmarkAll: false,
  });

  /**
   * Get available list menus at latest generalInfo.json then
   * show list menu bookmarks
   *
   * Because menu can be deleted, if menu deleted, the menu in bookmark saved in localStore should not be shown
   */
  const availableMenuIds = useMemo(() => {
    if (menus) {
      const menuIds = menus.map((menu) => menu.id);
      const availableMenuIds = [];
      Object.keys(contextValue.state?.bookmark).forEach((menuId) => {
        if (menuIds.includes(menuId)) {
          availableMenuIds.push(menuId);
        }
      });

      return availableMenuIds;
    }
    return ["single_menu"];
  }, [contextValue.state, menus]);

  const handleSelectUnBookmark = (item) => {
    setConfirmUnBookmark({
      item,
      toggleModal: true,
      unBookmarkAll: false,
    });
  };

  const handleSelectUnbookmarkAll = () => {
    setConfirmUnBookmark({
      item: null,
      toggleModal: true,
      unBookmarkAll: true,
    });
  };

  const handleResetUnBookmark = () => {
    setConfirmUnBookmark({
      item: null,
      toggleModal: false,
      unBookmarkAll: false,
    });
  };

  const handleUnbookmark = () => {
    const { item, unBookmarkAll } = confirmUnBookmark;

    contextValue.dispatch({
      type: unBookmarkAll ? TYPES.RESET_BOOKMARK : TYPES.REMOVE_BOOKMARK,
      bookmark: item,
    });

    handleResetUnBookmark();
  };

  return (
    <>
      <Modal
        show={confirmUnBookmark.toggleModal}
        onHide={handleResetUnBookmark}
      >
        <Modal.Header closeButton>
          <Modal.Title>Bookmarks</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {confirmUnBookmark.unBookmarkAll
            ? "Do you want to delete all items?"
            : "Do you want to delete this item?"}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            aria-label="No"
            title="No"
            onClick={handleResetUnBookmark}
          >
            No
          </Button>
          <Button
            variant="primary"
            aria-label="Yes"
            title="Yes"
            onClick={handleUnbookmark}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <section className="bookmark-section mt-4">
        <Container>
          <Link
            to="/"
            aria-label="Link to home"
            title="Home"
            className="d-flex align-items-center"
          >
            <Home className="mr-1" /> Home
          </Link>
          <h3 className="mt-2">Your Bookmarks</h3>
          {availableMenuIds.length ? (
            <>
              <Button
                variant="link"
                aria-label="Remove all"
                title="Remove all"
                className="p-0  mb-4"
                onClick={handleSelectUnbookmarkAll}
              >
                <em>Remove all</em>
              </Button>
              {availableMenuIds.map((id) => {
                const menu = contextValue.state.bookmark[id];
                return menu?.bookmarks && menu?.bookmarks.length ? (
                  <div key={menu.id}>
                    <h5>
                      <em>{menu.name}</em>
                    </h5>
                    <>
                      {menu.bookmarks.map((item) => (
                        <div
                          className="d-flex justify-content-between mt-3 mb-3"
                          key={item.path}
                        >
                          <div className="d-flex pr-2">
                            <span style={{ width: 20 }} className="mr-2">
                              <BookMarkDark
                                className="mr-3 bookmark-icon"
                                onClick={() =>
                                  handleSelectUnBookmark({
                                    ...item,
                                    menuId: menu.id,
                                    bookmarkPath: item.path,
                                  })
                                }
                              />
                            </span>
                            <div className="bookmark-content">
                              <Link
                                to={`/${menu.id}/${item.menuIndex}#${item.path}`}
                              >
                                {item.name}
                              </Link>
                              &nbsp;
                              <span className="text-muted">
                                {item?.vintage || ""}
                              </span>
                              &nbsp;
                              <span className="text-muted">
                                {item?.format || ""}
                              </span>
                            </div>
                          </div>
                          <span className="font-italic">
                            {item?.price ? `$${item?.price}` : ""}
                          </span>
                        </div>
                      ))}
                    </>
                    <hr />
                  </div>
                ) : null;
              })}
            </>
          ) : (
            <Alert role="alert" variant="info">
              You don't have any bookmarked menus
            </Alert>
          )}
        </Container>
      </section>
    </>
  );
};

export default Bookmark;
